<template>
  <div>
    <title>商品列表</title>
    <section class="goodsBox">
      <!--S 检索-->
      <el-form :model="searchGLForm" inline class="serGlForm">
        <el-form-item label="关键词"><el-input v-model="searchGLForm.keyword" placeholder="请输入内容" clearable></el-input></el-form-item>
        <el-form-item label="商品分类">
          <!-- 商品分类下拉组件 -->
          <GoodsClassSelect :classInfo="{oneCode:searchGLForm.categorycode,twoCode:searchGLForm.tcategorycode}"
            @classObtain="calssReceive"></GoodsClassSelect>
          <!-- 商品分类下拉组件 -->
        </el-form-item>
        <el-form-item label="单品绑定状态" v-if="ElementControls('jinshizun')==1" class="formTimeSlot">
          <el-select v-model="searchGLForm.goodsBind" placeholder="请选择" clearable>
            <el-option label="已绑定" :value="2"></el-option>
            <el-option label="未绑定" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <!-- S 商品上下架组件 -->
        <GoodsBsale :bsale="searchGLForm.bsale" @goodsBsaleObtain="goodsBsaleReceive"></GoodsBsale>
        <!-- E 商品上下架组件 -->
        <el-form-item label="销售条码"><el-input v-model="searchGLForm.salesbarcode" placeholder="请输入内容"
            clearable></el-input></el-form-item>
        <el-form-item label="发货方">
          <FlowSelectPage @flowObtain="flowObtain" :flowCode="searchGLForm.shippercode"></FlowSelectPage>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="querySubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain :loading="exploading" @click="expdaochu">导出</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" plain @click="importPop = true">批量导入商品</el-button>
        </el-form-item> -->
      </el-form>
      <!--E 检索-->
      <div class="gsListTable individualiz" v-loading="loading">
        <el-form :model="searchGLForm" inline size="medium">
          <el-form-item class="borderline">
            <em class="redColor fwBold">商品归属</em>
            <el-checkbox-group v-model="searchGLForm.querytype" @change="queryUpdate">
              <el-checkbox :label="0">自主创建</el-checkbox>
              <el-checkbox :label="1">他人创建</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="borderline">
            <em class="redColor fwBold">商品用途</em>
            <el-checkbox-group v-model="searchGLForm.usefor" @change="purposeUpdate">
              <el-checkbox v-for="(item,index) in useforLists" :label="item.value"
                :key="index">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="borderline" v-if="openSupplyper==1">
            <em class="greyColor"></em>
            <el-checkbox-group v-model="searchGLForm.coostatus" @change="coostatusUpdate">
              <el-checkbox :label="1">参与仓分享</el-checkbox>
              <el-checkbox :label="3">禁止发布</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="borderline">
            <em class="greyColor"></em>
            <el-checkbox-group v-model="searchGLForm.supplyfor" @change="querySubmit">
              <el-checkbox v-for="(item,index) in supplyLists" :label="item.value"
                :key="index">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="borderline">
            <em class="greyColor"></em>
            <el-checkbox v-model="searchGLForm.sort" key="showpos">按展示顺序排序</el-checkbox>
          </el-form-item>
          <el-form-item class="borderline borderNone">
            <em class="greyColor"></em>
            <el-checkbox v-show="ElementControls('open_goods_extend')==1" v-model="searchGLForm.canextendattr"
              key="showpos" @change="canextendattrChang">支持商品扩展属性</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain v-show="!goodsStatus && !riskStatus" @click="groupUpper(1)">批量上架</el-button>
            <el-button type="primary" plain v-show="!goodsStatus && !riskStatus" @click="groupUpper(0)">批量下架</el-button>
            <el-button type="danger" v-show="goodsStatus" icon="el-icon-close" round @click="confirmCancel(0)">取消</el-button>
            <el-button type="success" v-show="goodsStatus" icon="el-icon-check" round @click="confirmCancel(1)">确定</el-button>
          </el-form-item>
          <el-form-item v-show="!goodsStatus && !riskStatus">
            <el-button type="primary" plain @click="goBasicInfo">新增商品</el-button>
            <el-button type="primary" plain @click="specMange = true">规格管理</el-button>
            <el-button type="primary" plain @click="categroyMangeShow = true">批量修改</el-button>
          </el-form-item>
          <el-form-item v-show="!goodsStatus">
            <el-button type="primary" plain v-show="!riskStatus" @click="groupRisk(1)"
              v-if="ElementControls('jinshizun')==1&&ElementControls('saleordercontrprice')==1">批量控价</el-button>
            <el-button type="danger" v-show="riskStatus" icon="el-icon-close" round
              @click="riskCancel(0)">取消</el-button>
            <el-button type="success" v-show="riskStatus" icon="el-icon-check" round
              @click="riskCancel(1)">确定</el-button>
          </el-form-item>
        </el-form>
        <!--S 商品列表-->
        <el-table ref="gsTable" class="gsTable comTable" border :data="goodsList" :maxHeight="tableHeight"
          @selection-change="handleSelectionChange">
          <el-table-column v-if="goodsStatus || riskStatus" type="selection" width="100"
            :selectable="selectTrue"></el-table-column>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column label="商品分类" min-width="300">
            <template slot-scope="scope">
              <el-tag v-if="returnOperate(scope.row)" type="primary" plain title="自主创建">自创</el-tag>
              <el-tag v-else type="danger" plain title="他人创建">他创</el-tag>
              <p class="textFl" :title="scope.row.categoryname">{{scope.row.categoryname}}</p>
              <small class="textFl" :title="scope.row.tcategoryname" v-if="bopentclassify == 1">{{scope.row.tcategoryname}}</small>
            </template>
          </el-table-column>
          <el-table-column label="商品内容" prop="goodsname" sortable min-width="400">
            <template slot-scope="scope">
              <section class="flexAro pdr70">
                <span class="goodsImg"><img width="80px"
                    :src="scope.row.kindpic?scope.row.kindpic:(scope.row.maingoodspic?scope.row.maingoodspic:'')"
                    onerror="this.src='https://presale.jhtsoft.com/picms/c47499b67d489.png'" /></span>
                <div class="goodsCont">
                  <h3 :title="scope.row.goodsname">{{scope.row.goodsname}}</h3>
                  <p :title="scope.row.kindinfo">{{scope.row.kindinfo}}</p>
                  <dl>
                    <dt class="priceFont" v-if="scope.row.kindcode"><i>￥</i>{{scope.row.goodsmallprice | formatAmount}}
                    </dt>
                    <dd>
                      <el-tag v-if="scope.row.usefor.indexOf('2')!=-1" type="danger" effect="dark"
                        title="商城销售">售</el-tag>
                      <el-tag v-if="scope.row.usefor.indexOf('0')!=-1" type="primary" effect="dark"
                        title="券卡兑换">兑</el-tag>
                      <el-tag v-if="scope.row.usefor.indexOf('1')!=-1" type="success" effect="dark"
                        title="商品溯源">溯</el-tag>
                      <el-tag v-if="ElementControls('openScheme')==1 &&scope.row.usefor.indexOf('3')!=-1" type="danger"
                        effect="dark" title="福利方案">福</el-tag>
                      <span class="iconminpragram minProgramTip" v-if="ElementControls('OpenMiniProgram') == 1 &&scope.row.usefor.indexOf('4')!=-1" title="小程序商城"></span>
                      <el-tag v-if="scope.row.coostatus==1" effect="dark" title="参与仓分享">仓</el-tag>
                      <el-tag type="warning" v-if="scope.row.bexpresalegoods==1" effect="dark" title="推荐商品">荐</el-tag>
                      <el-tag type="success" v-if="scope.row.isgift==1" effect="dark" title="赠品">赠</el-tag>
                      <el-tag type="warning" v-if="scope.row.postagefree==1" effect="dark" title="包邮">包</el-tag>
                      <el-tag type="success" effect="dark" v-show="ElementControls('open_goods_extend')==1"
                        v-if="scope.row.canextendattr==1" title="支持商品扩展属性">扩</el-tag>
                    </dd>
                  </dl>
                  <!-- <el-tag type="danger" plain v-if="scope.row.coostatus==3">禁止发布</el-tag> -->
                </div>
              </section>
            </template>
          </el-table-column>
          <el-table-column label="控价属性" min-width="200"
            v-if="ElementControls('jinshizun')==1&&ElementControls('saleordercontrprice')==1">
            <template slot-scope="scope">
              <p class="priceFont riskPrice"><em class="iconzhike" title="直客控价"></em>直客：<i>￥</i><b
                  class="priceFont redColor">{{scope.row.directprice | formatAmount}}</b></p>
              <p class="priceFont riskPrice"><em class="iconqvdao" title="渠道控价"></em>渠道：<i>￥</i><b
                  class="priceFont redColor">{{scope.row.channelprice | formatAmount}}</b></p>
            </template>
          </el-table-column>
          <el-table-column label="上/下架" prop="bsale" sortable min-width="200">
            <template slot-scope="scope" v-if="scope.row.kindcode&&scope.row.kindcode!=null">
              <el-switch :value="scope.row.bsale?true:false" @change="switchChange(scope.row)" :width="55"
                class="isSwitch" :active-text="scope.row.bsale?'上架':'下架'" :disabled="!returnOperate(scope.row)"></el-switch>
              <small>录入时间：{{dateTime(scope.row.credate,1)}}</small>
              <small v-if="scope.row.credate!=scope.row.upddate">修改时间：{{dateTime(scope.row.upddate,1)}}</small>
              <el-tag type="warning" plain title="未绑定单品"
                v-if="scope.row.kindcode&&scope.row.bindsingle!=2&&ElementControls('jinshizun')==1">未绑定单品</el-tag>
              <el-tag type="danger" plain v-if="scope.row.coostatus==3">禁止发布</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150">
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand" placement="bottom-start">
                <span class="el-dropdown-link">
                  全部操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{type:'goodsMange',info:scope.row}">商品{{returnOperate(scope.row)?'管理':'详情'}}</el-dropdown-item>
                  <el-dropdown-item :command="{type:'kindinfoMange',info:scope.row}">规格{{returnOperate(scope.row)?'管理':'详情'}}</el-dropdown-item>
                  <el-dropdown-item :command="{type:'membertype',info:scope.row}"
                    v-if="ElementControls('jinshizun')==1&&ElementControls('saleordercontrprice')==1&&returnOperate(scope.row)">控价设置</el-dropdown-item>
                  <el-dropdown-item :command="{type:'inventroyMange',info:scope.row}" v-if="scope.row.kindcode&&baseInvcontrol&&scope.row.pinvcontrol&&returnOperate(scope.row)">库存管理</el-dropdown-item>
                  <el-dropdown-item :command="{type:'goodsSafeguard',info:scope.row}"
                    v-if="scope.row.kindcode&&ElementControls('jinshizun')==1&&returnOperate(scope.row)">单品维护</el-dropdown-item>
                  <!-- <el-dropdown-item :command="{type:'createVouchers',info:scope.row}" v-if="scope.row.kindcode">生成礼品券</el-dropdown-item> -->
                  <el-dropdown-item :command="{type:'deleteGoods',info:scope.row}" v-if="returnOperate(scope.row)">删除</el-dropdown-item>
                  <el-dropdown-item :command="{type:'getLinks',info:scope.row}"
                    v-if="scope.row.kindcode&&!scope.row.isgift&&scope.row.usefor.indexOf('2')!=-1">获取链接</el-dropdown-item>
                  <el-dropdown-item :command="{type:'copyCreate',info:scope.row}"
                    v-if="ElementControls('jinshizun')!=1&&returnOperate(scope.row)">一键复制商品</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="noData"><span>暂无数据</span></div>
          </template>
        </el-table>
        <!--E 商品列表-->
      </div>
      <!-- S 分页 -->
      <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
      <!-- S 分页 -->
    </section>

    <!-- S 规格管理弹窗 -->
    <KindAdminister :goodsType="0" :specMange="specMange" @closeKindPop="closeKindPope"></KindAdminister>
    <!-- E 规格管理弹窗 -->

    <!-- S 批量改分类组件 -->
    <categroyMange :categroyMangeBox="categroyMangeShow" :sourceType="0" :goodsType="0"
      @closeCategroyBox="closeCategroyBox"></categroyMange>
    <!-- E 批量改分类组件 -->

    <!--S 下架备注组件-->
    <LowerMemo :lowerMemoBox="lowerPopShow" :goodsLower="goodsLower" :muitiBath="muitiBath" :haveSelUserfor="rowInfo.usefor" :operateUpper="operateUpper" :sourceType="0" :goodsType="0" @closeLMemoBox="closeLowerMemo"></LowerMemo>
    <!--E 下架备注组件-->

    <!--S 生成礼品券-->
    <el-dialog class="comDlog outDetailDlog" title="生成礼品券规则" :visible.sync="autoGift" :close-on-click-modal="false"
      :close-on-press-escape="false" append-to-body>
      <el-form v-model="labelPosition" label-width="150px">
        <!-- S 券卡规则组件 -->
        <ModifyCardRule useType="商品" :isReset="autoGift"></ModifyCardRule>
        <!-- E 券卡规则组件 -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="autoGiftFn(1)">确定</el-button>
        <el-button @click="autoGiftFn(0)">取消</el-button>
      </span>
    </el-dialog>
    <!--E 生成礼品券-->

    <!--S 获取链接组件-->
    <CopyLink :linkDetailBox="linkDetail" :linkTitle="linkTitle" :doubleLink="doubleLink" :copyInfo="goodsInfo"
      @closeLinkBox="linkDetail = false">
    </CopyLink>
    <!--E 获取链接组件-->

    <!--S 单品维护弹窗-->
    <el-dialog :visible.sync="itemMaintenanceShow" title="单品维护" class="comDlog maintenanceDlg"
      :close-on-click-modal="false" append-to-body>
      <!--S 选择单品组件-->
      <SelectSingleGoods :singleShow="itemMaintenanceShow" :selSingleType="1" :kindcode="operKindCode"
        v-if="itemMaintenanceShow" @setSingleGoods="setSingleGoods"></SelectSingleGoods>
      <!--E 选择单品组件-->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getClosePurchase(1)">确定</el-button>
        <el-button @click="getClosePurchase">取消</el-button>
      </span>
    </el-dialog>
    <!--E 单品维护弹窗-->


    <!--S 一键复制创建商品弹窗-->
    <AutoCreateGoods :autoCreateShow="autoCreateShow" :goodsInfo="goodsInfo" @closeChild="handleCloseAutoCreate"
      v-if="autoCreateShow"></AutoCreateGoods>
    <!--E 一键复制创建商品弹窗-->

    <!-- S 控价设置弹窗 -->
    <Riskcontrol :riskcontrolShow="riskcontrolShow" :goodsInfo="riskType==1?goodsInfo:''" @closeCld="getCloseRiskDlog"
      :isBatch="isBatch"></Riskcontrol>
    <!-- E 控价设置弹窗 -->
    <!-- S 批量导入商品弹窗 -->
    <ImportGoods :importPop="importPop" @closeImportPop="closeImportPop"></ImportGoods>
    <!-- E 批量导入商品弹窗 -->

  </div>
</template>
<script>
  import { MessageBox } from "element-ui";
  import api from '../../../apis/api.js'
  import { bus } from '../../../util/bus.js';
  import { mapState, mapActions } from "vuex";
  import Vue from 'vue'
  export default {
    name: 'GoodsList',
    data() {
      return {
        exploading: false,
        linkDetail: false,//获取链接弹框
        linkTitle: '访问链接：',//链接标题
        doubleLink: true,//双链接
        goodsLower: true,
        goodsType: 0, // 商品类型
        goodsInfo: '', // 操作的商品信息
        operKindCode: '', // 操作商品的规格编号
        operGoodsCode: '', // 操作商品的商品编号
        vouchersInfo: '', // 需要生成礼品券卡的商品信息
        loading: true, // 加载中弹窗显示和隐藏
        useforLists: [ //商品用途 0：预售；1：溯源；2：营销（复选项，中间以#隔开this.usefor.join('#')）
          { label: '商城销售', value: '2' },
          { label: '券卡兑换', value: '0' },
          { label: '商品溯源', value: '1' },
        ],
        supplyLists: [
          { label: '推荐商品', value: 'bexpresalegoods' },
          { label: '作为赠品', value: 'isgift' },
          { label: '包邮', value: 'freeshipping' },
        ],
        searchGLForm: {
          keyword: '',//关键词
          categorycode: '', //选中分类编号
          tcategorycode: '', //选中二级分类编号
          bsale: '1', //是否上架
          usefor: [], // 商品用途。0：预售；1：溯源；2：营销（复选项，中间以#隔开this.usefor.join('#')）
          supplyfor: [], //作为什么使用supplyLists
          coostatus: [], //是否参与仓分享
          bexpresalegoods: '', //是否是推荐商品
          isgift: '',//是否作为赠品
          postagefree: '',//是否包邮
          salesbarcode: '', // 销售条码
          goodsBind: '', // 是否绑定单品
          sort: '', // 排序检索 showpos按升序
          shippercode: '', // 发货方编号
          canextendattr: false,//是否支持扩展属性
          querytype: [0], // 商品归属查询 0：自己创建的；1：他人创建的；不传查询所有的；
        },
        pageSize: 30, // 每页展示的条数
        currentPage: 1, // 当前请求的页数
        pagebBean: {
          totalnum: 0,
        }, // 获取到的列表分页信息
        goodsList: [], // 获取到的商品列表
        goodsStatus: false, //批量上架状态
        operateUpper: null, //批量上下架操作
        multipleSelection: [], //已选中的行
        bsaleCodes: '', // 上下架操作的商品规格编号
        lowerPopShow: false, //下架备注弹窗
        lowerMemo: '', // 下架备注
        tableHeight: window.innerHeight * .8, //表格动态高度
        specMange: false, //规格管理弹窗
        autoGift: false, //生成礼品券弹窗
        btnRuleVal: '',//确定、取消生成礼品券
        autoGiftOne: true, // 是否是第一次点击生成礼品券卡弹窗
        categroyMangeShow: false, //批量改分类
        //-----------------券卡规则变量 Start-------------------
        labelPosition: "right", //labe文字右对齐
        goodsArray: [], // 单个专区选择的商品列表
        //-----------------券卡规则变量 End-------------------
        heightTrue: false, // 是否已经获取过高度
        baseInvcontrol: 0, // 商家是否开通库存控制
        firstTrue: true, // 防止多次点击提交
        bopentclassify: 0, // 是否开通二级分类
        itemMaintenanceShow: false,//单品维护弹窗
        singleGoodsList: [], // 选择的单品编号
        singleErrList: [], // 过滤错误列表信息
        openSupplyper: 0, // 商家是否开通供货
        sharestatus: -1, // 企业申请供方是否通过
        autoCreateShow: false,//一键复制新增弹窗
        riskcontrolShow: false,//控价设置弹窗
        riskStatus: false,//批量控价状态
        riskType: 0, // 操作控价的类型 0为批量 1为单独
        isBatch: false,//是否是批量控价设置，默认false
        patchName: '', // 来源路由路径name
        operateType: 0, // 操作的类型 0为新增 1为编辑
        importPop: false, // 批量导入商品弹窗是否显示
        userInfoMd: {}, // 门店登录信息
        rowInfo:'',//当前商品
        muitiBath:0,//是否是批量操作
      }
    },
    filters: {

    },
    components: {
      Page: resolve => require(["@/components/common/Page.vue"], resolve),
      LowerMemo: resolve => require(["@/components/GoodsFolder/LowerMemo.vue"], resolve), //下架备注组件
      GoodsClassSelect: resolve => require(["@/components/common/GoodsClassSelect.vue"], resolve), // 商品分类下拉组件
      GoodsBsale: resolve => require(["@/components/Gadget/GoodsBsale.vue"], resolve), // 上下架下拉组件
      ModifyCardRule: resolve => require(["@/components/CardsFolder/ModifyCardRule.vue"], resolve), // 券卡规则组件
      KindAdminister: resolve => require(["@/components/GoodsFolder/KindAdminister.vue"], resolve), // 规格管理商品弹窗
      CopyLink: resolve => require(["@/components/common/CopyLink.vue"], resolve), //获取链接组件
      categroyMange: resolve => require(["@/components/GoodsFolder/categroyMange.vue"], resolve), //批量修改分类组件
      SelectSingleGoods: resolve => require(["@/components/GoodsFolder/GoodsSingle/SelectSingleGoods.vue"], resolve), //选择单品组件
      AutoCreateGoods: resolve => require(["@/components/GoodsFolder/AutoCreateGoods.vue"], resolve),//一键复制新建商品信息
      Riskcontrol: resolve => require(["@/components/GoodsFolder/Riskcontrol.vue"], resolve),//控价属性
      FlowSelectPage: resolve => require(["@/components/common/FlowSelectPage.vue"], resolve), // 发货方下拉组件 带分页
      ImportGoods: resolve => require(["@/components/GoodsFolder/ImportGoods.vue"], resolve),//批量导入商品弹窗
    },
    // ============================================== 监听 ==============================================
    watch: {
      'searchGLForm.sort'(val) {
        // 查询确定事件
        this.querySubmit();
      },
      '$route'(to, from) {
        this.patchName = from.name;
      }
    },
    computed: {
      ...mapState({
        cardRule: ({ common }) => common.cardRule, // 券卡规则
      })
    },
    // ============================================== 方法 ==============================================
    methods: {
      // 判断是否有操作权限
      returnOperate(row) {
        if(row.belongcode&&row.belongcode!='0'&&(row.belongcode==this.userInfoMd.flowcode || row.belongcode==this.userInfoMd.pflowcode)) {
          return true;
        } else {
          return false;
        }
      },
      canextendattrChang() {
        this.querySubmit();
      },
      ...mapActions(["areaArrayStore"]),
      // 关闭批量导入商品弹窗
      closeImportPop(type) {
        if(type == 1) {
          this.querySubmit();
        }
        this.importPop = false;
      },
      //导出
      expdaochu() {
        let Param = {
          keyword: this.searchGLForm.keyword, // 关键字
          goodssource: 0, // 商品来源
          catetype: this.goodsType, // 商品类型
          categorycode: this.searchGLForm.categorycode, // 商品分类编号
          tcategorycode: this.searchGLForm.tcategorycode, // 二级商品分类编号
          bsale: this.searchGLForm.bsale !== '' ? this.searchGLForm.bsale : null, // 上下架
          bexpresalegoods: this.searchGLForm.supplyfor.indexOf('bexpresalegoods') != -1 ? 1 : null, // 是否参与促销
          isgift: this.searchGLForm.supplyfor.indexOf('isgift') != -1 ? 1 : null, // 是否为赠品
          postagefree: this.searchGLForm.supplyfor.indexOf('freeshipping') != -1 ? 1 : null, // 是否包邮
          usefor: this.searchGLForm.usefor[0] ? this.searchGLForm.usefor.join(',') : null, // 商品用途
          // coostatus: this.searchGLForm.coostatus.length>0?this.searchGLForm.coostatus[0]:null, // 是否参与仓分享
          salesbarcode: this.searchGLForm.salesbarcode, // 销售条码
          bindsingle: this.searchGLForm.goodsBind !== '' ? this.searchGLForm.goodsBind : null, // 销售条码
          // cardgoods: true, // 是否只获取有规格商品
          sort: this.searchGLForm.sort ? 'showpos' : null, // 排序检索
          shippercode: this.searchGLForm.shippercode, // 发货方
          canextendattr: this.searchGLForm.canextendattr ? 1 : null,
          querytype: this.searchGLForm.querytype.length?this.searchGLForm.querytype[0]:null
        };
        this.exploading = true;
        api.GET_EXPORTGOODS(Param).then(res => {
          if (res.data.status == "200") {
            this.exploading = false;
            window.location.href = res.data.data
            this.$message.success(res.data.message)
          } else {
            this.exploading = false;
            this.$message.error(res.data.message)
          }
        }).catch((err) => {
          this.exploading = false;
        })
      },
      // 获取商品列表数据
      getGoodsList() {
        this.loading = true;
        let goodsParam = {
          keyword: this.searchGLForm.keyword, // 关键字
          goodssource: 0, // 商品来源
          catetype: this.goodsType, // 商品类型
          categorycode: this.searchGLForm.categorycode, // 商品分类编号
          tcategorycode: this.searchGLForm.tcategorycode, // 二级商品分类编号
          bsale: this.searchGLForm.bsale !== '' ? this.searchGLForm.bsale : null, // 上下架
          bexpresalegoods: this.searchGLForm.supplyfor.indexOf('bexpresalegoods') != -1 ? 1 : null, // 是否参与促销
          isgift: this.searchGLForm.supplyfor.indexOf('isgift') != -1 ? 1 : null, // 是否为赠品
          postagefree: this.searchGLForm.supplyfor.indexOf('freeshipping') != -1 ? 1 : null, // 是否包邮
          usefor: this.searchGLForm.usefor[0] ? this.searchGLForm.usefor.join(',') : null, // 商品用途
          coostatus: this.searchGLForm.coostatus.length > 0 ? this.searchGLForm.coostatus[0] : null, // 是否参与仓分享
          canextendattr: this.searchGLForm.canextendattr ? 1 : null,
          salesbarcode: this.searchGLForm.salesbarcode, // 销售条码
          bindsingle: this.searchGLForm.goodsBind !== '' ? this.searchGLForm.goodsBind : null, // 销售条码
          // cardgoods: true, // 是否只获取有规格商品
          sort: this.searchGLForm.sort ? 'showpos' : null, // 排序检索
          shippercode: this.searchGLForm.shippercode, // 发货方
          querytype: this.searchGLForm.querytype.length?this.searchGLForm.querytype[0]:null,
          pageparam: {
            pagesize: this.pageSize, //每页条数
            currentpage: this.currentPage, //当前页数
            isnewcomp: 1 //是否需要重新统计页数
          }
        };
        api.GET_GOODSLIST(goodsParam).then(res => {
          this.toTableTop('gsTable');
          if (res.data.status == "200") {
            this.goodsList = res.data.data;
            this.pagebBean = res.data.pagebean;
            //在dom渲染之后
            if (!this.heightTrue) {
              setTimeout(() => {
                this.getHeight();
                this.heightTrue = true;
              }, 500);
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            })
          }
          this.loading = false;
        })
      },
      // 检索商品归属
      queryUpdate() {
        if (this.searchGLForm.querytype.length > 1) {
          this.searchGLForm.querytype.splice(0, 1);
        }
        this.querySubmit();
      },
      // 选检索的商品用途
      purposeUpdate() {
        this.querySubmit()
      },
      // 仓分享状态
      coostatusUpdate() {
        if (this.searchGLForm.coostatus.length > 1) {
          this.searchGLForm.coostatus.splice(0, 1);
        }
        this.querySubmit();
      },
      // 查询确定事件
      querySubmit(val) {
        this.currentPage = 1;
        this.getGoodsList();
      },
      // 接收分页信息
      updatePage(size, num) {
        this.pageSize = size;
        this.currentPage = num;
        this.goodsStatus = false;
        this.riskStatus = false;
        this.getGoodsList();
      },
      // 表格多选选中行复制
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //批量上下架
      groupUpper(val) {
        this.muitiBath = 1;
        this.operateUpper = val;
        this.goodsStatus = true;
      },
      // 判断多选框是否可以选择方法
      selectTrue(val) {
        if(this.returnOperate(val)) {
          if (this.riskStatus) {
            if (val.kindcode) {
              return true;
            } else {
              return false;
            }
          } else {
            if ((val.bsale == 0 && this.operateUpper == 1) || (val.bsale == 1 && this.operateUpper == 0)) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          return false;
        }
      },
      //单独上下架
      switchChange(val) {
        this.rowInfo = val;
        this.muitiBath = 0;
        this.bsaleCodes = val.kindcode;
        if (val.bsale == 0) {
          this.operateUpper = 1;
          if(Number(this.ElementControls('system_version')) < 2 || this.ElementControls('system_version') == 9){
            if(this.ElementControls('giftCardToMallCoin')==1){
              this.lowerPopShow = true; 
            }else{
              MessageBox.confirm('确定上架该商品吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.batchUpdStatus();
              }).catch(() => { });
            }
          }else{
            this.lowerPopShow = true; 
          }
        } else {
          this.operateUpper = 0;
          this.lowerPopShow = true; //下架备注弹窗
        }
      },
      //确定/取消批量上下架
      confirmCancel(val) {
        if (val == 1) {
          if (this.multipleSelection.length > 0) {
            this.bsaleCodes = '';
            this.multipleSelection.forEach(item => {
              if (!this.bsaleCodes) {
                this.bsaleCodes = item.kindcode;
              } else {
                this.bsaleCodes = this.bsaleCodes + ',' + item.kindcode;
              }
            });
            if (this.operateUpper == 1) { // 上架操作
              MessageBox.confirm('确定上架勾选商品吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.batchUpdStatus();
              }).catch(() => { });
            } else { // 下架弹窗显示
              this.lowerPopShow = true;
            }
          } else {
            MessageBox.alert('请至少勾选一项！', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => { }).catch(() => { });
          }
        } else {
          this.goodsStatus = false;
          this.$refs.gsTable.clearSelection(); // 清空选中列表数据
        }
      },
      //确定下架备注
      closeLowerMemo(val) {
        this.lowerPopShow = false; //弹窗
        if (val !== '' && val !== undefined) {
          this.lowerMemo = val;
          this.batchUpdStatus();
        }
      },
      // 上下架提交接口
      batchUpdStatus() {
        if (this.firstTrue) {
          let bsaleParams = {
            bsale: Number(this.operateUpper),
            codetype: 1,
            codes: this.bsaleCodes,
          }
          if (this.operateUpper != 1) {
            bsaleParams.unshelvememo = this.lowerMemo.unshelvememo; 
          }
          if((this.ElementControls('system_version') ==1 && this.ElementControls('giftCardToMallCoin')==1) || (Number(this.ElementControls('system_version')) >= 2 && this.ElementControls('system_version') != 9)){
            bsaleParams.type = this.lowerMemo.bdirectsales;
          }
          if(this.muitiBath == 0){
            bsaleParams.updateusefor = this.lowerMemo.updateusefor;
            bsaleParams.usefor = this.lowerMemo.usefor;
          }
          this.firstTrue = false;
          api.BATCHUPDSTATUS(bsaleParams).then(res => {
            if (res.data.status == "200") {
              this.$message({
                type: 'success',
                message: res.data.message
              });
              this.goodsStatus = false;
              this.$refs.gsTable.clearSelection(); // 清空选中列表数据
              this.getGoodsList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
            this.firstTrue = true;
          }).catch(res => {
            this.firstTrue = true;
          })
        }
      },
      //下拉框取值
      calssReceive(value) {
        if (value.length > 0) {
          if (value.length == 2) {
            this.searchGLForm.categorycode = value[0];
            this.searchGLForm.tcategorycode = value[1];
          } else {
            this.searchGLForm.categorycode = value[0];
          }
        } else {
          this.searchGLForm.categorycode = '';
          this.searchGLForm.tcategorycode = '';
        }
      },
      // 上下架下拉选择值
      goodsBsaleReceive(val) {
        this.searchGLForm.bsale = val;
      },
      // 发货方下拉取值
      flowObtain(val) {
        this.searchGLForm.shippercode = val;
      },

      // 实物商品操作指令
      handleCommand(command) {
        this.goodsInfo = command.info; // 操作的商品信息
        this.operKindCode = command.info.kindcode; // 操作商品的规格编号
        this.operGoodsCode = command.info.goodscode; // 操作商品的商品编号
        if (command.type == 'goodsMange') { //商品管理
          this.operateType = 1;
          this.$router.push({
            name: '基本信息',
            params: {
              goodscode: this.operGoodsCode
            },
            query: {
              haveKind: command.info.kindcode ? '1' : '0',
              operateTrue: this.returnOperate(command.info)?1:0
            }
          })
        } else if (command.type == 'kindinfoMange') { //规格管理
          this.operateType = 1;
          this.$router.push({
            name: '规格管理',
            params: {
              goodscode: this.operGoodsCode
            },
            query: {
              kindcode: this.operKindCode,
              operateTrue: this.returnOperate(command.info)?1:0
            }
          })
        } else if (command.type == 'inventroyMange') { //库存管理
          this.operateType = 1;
          this.$router.push({
            name: '库存管理',
            params: {
              goodscode: this.operGoodsCode
            },
            query: {
              kindcode: this.operKindCode,
              operateTrue: this.returnOperate(command.info)?1:0
            }
          })
        } else if (command.type == 'cooperativeMange') { //合作管理
          console.log('合作管理')
        } else if (command.type == 'goodsSafeguard') { //单品维护
          this.itemMaintenanceShow = true;
        } else if (command.type == 'createVouchers') { //生成礼品券
          let checkParams = {
            goodscode: this.operGoodsCode,
            kindcode: this.operKindCode
          }
          api.CHECKVOUCHERSEXIST(checkParams).then(res => {
            if (res.data.status == "200") {
              this.vouchersInfo = command.info;
              // 接收生成礼品券商品信息
              this.autoGift = true;
              // if(this.autoGiftOne) {
              setTimeout(() => {
                bus.$emit('getGoodsInfo', this.vouchersInfo);
              }, 300)
              //   this.autoGiftOne = false;
              // }else {
              //   bus.$emit('getGoodsInfo',this.vouchersInfo);
              // }
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          })
        } else if (command.type == 'deleteGoods') { // 删除商品
          this.deleteGoods();
        } else if (command.type == 'getLinks') { //获取链接
          this.getLinks();
        } else if (command.type == 'copyCreate') {
          this.autoCreateShow = true;
        } else if (command.type == 'membertype') {//控价设置
          this.riskType = 1;
          this.isBatch = true;
          this.riskcontrolShow = true;
        }

      },
      //获取链接
      getLinks() {
        this.linkDetail = true;
      },
      // 删除商品方法
      deleteGoods() {
        if (this.firstTrue) {
          MessageBox.confirm('确定删除该商品吗？此商品下的规格也将一并删除！', '确认提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            let delParams = {
              catetype: this.goodsType,
              gtype: 0,
              code: this.operGoodsCode
            };
            this.firstTrue = false;
            api.DELETEGOODS(delParams).then(res => {
              if (res.data.status == "200") {
                this.$message({
                  type: 'success',
                  message: res.data.message
                });
                this.querySubmit();
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
              }
              this.firstTrue = true;
            }).catch(res => {
              this.firstTrue = true;
            })
          }).catch(() => { });
        }
      },
      //新增商品，判断商品类型进入基本信息页
      goBasicInfo() {
        this.operateType = 0;
        this.$router.push({
          path: '/GoodsBasicInfo/*?operateTrue=1'
        });
      },
      // 关闭管理规格选择弹窗
      closeKindPope(type) {
        this.specMange = false;
        this.operateType = type;
      },
      //关闭批量修改分类弹窗
      closeCategroyBox(type) {
        if (type == 1) {
          this.querySubmit();
        };
        this.categroyMangeShow = false;
      },
      //批量控价
      groupRisk(val) {
        this.riskStatus = true;
      },
      //确定/取消批量控价
      riskCancel(val) {
        if (val == 1) {
          this.operKindCode = '';
          if (this.multipleSelection.length > 0) {
            this.multipleSelection.forEach(item => {
              if (!this.operKindCode) {
                this.operKindCode = item.kindcode;
              } else {
                this.operKindCode = this.operKindCode + ',' + item.kindcode;
              }
            });
            this.riskType = 0;
            this.isBatch = false;
            this.riskcontrolShow = true;
          } else {
            MessageBox.alert('请至少勾选一项！', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => { }).catch(() => { });
          }
        } else {
          this.riskStatus = false;
          this.$refs.gsTable.clearSelection(); // 清空选中列表数据
        }
      },
      // 关闭控价设置弹窗
      getCloseRiskDlog(info) {
        if (info) {
          if (this.firstTrue) {
            let batchParams = {
              kindcodes: this.operKindCode,
              directprice: info.directprice,
              channelprice: info.channelprice,
            }
            this.firstTrue = false;
            api.BATCHSETGOODSCONTROLPRICE(batchParams).then(res => {
              if (res.data.status == "200") {
                this.$message({
                  type: 'success',
                  message: res.data.message
                })
                this.getGoodsList();
                this.riskcontrolShow = false;
                this.riskStatus = false;
                this.$refs.gsTable.clearSelection(); // 清空选中列表数据
                setTimeout(() => {
                  this.firstTrue = true;
                }, 10);
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                })
              }
              this.firstTrue = true;
            }).catch(res => {
              this.firstTrue = true;
            })
          }
        } else {
          this.riskcontrolShow = false;
          this.riskStatus = false;
          this.$refs.gsTable.clearSelection(); // 清空选中列表数据
        }
      },
      //---------------券卡规则 method Start-------------
      //关闭生成礼品券弹窗
      autoGiftFn(val) {
        if (val) {
          if (this.firstTrue) {
            if (!this.brandInfo.brandcode) {
              return;
            }
            if ((this.cardRule.cardcategory || this.cardRule.tcCardcategory || this.cardRule.deCardcategory) && this.brandInfo.exchangemode != 0) {
              this.$message({
                type: 'error',
                message: "组合卡设置,仅能选择传统拆单的品牌"
              });
              return;
            }
            if (this.cardRule.optsselecttype == 1) {
              // 多专区商品选择数量控制类型为共享控制数量时，不进行专区商品数量校验
              let isTrue = true;
              this.cardRule.areainfo.forEach(item => {
                if (!item.optgoodscode && !item.optgoodsname) {
                  isTrue = false;
                  this.$message({
                    type: 'error',
                    message: `${item.zonename}商品不能为空！`
                  });
                  return true
                }
              })
              let listnum = 0;
              this.cardRule.areainfo.forEach(item => {
                listnum += item.listnum;
              })
              if (listnum < this.cardRule.selnum) {
                isTrue = false;
                this.$message({
                  type: 'error',
                  message: '专区可选择商品数量不能小于券卡可选择商品数量!'
                });
                return false
              }
              if (!isTrue) {
                return true
              }
              console.log(this.cardRule,'this.cardRule')
            }else if (!this.cardRule.tcCardcategory && !this.cardRule.deCardcategory) {
              if (this.cardRule.areainfo.length == 1) {
                if (this.cardRule.areainfo[0].listnum < this.cardRule.areainfo[0].zoneselnum) {
                  this.$message({
                    type: 'error',
                    message: '专区供选择商品数量不能小于可选择商品数量!'
                  });
                  return false
                }
              } else {
                let areaGoodsNum = 0;
                this.cardRule.areainfo.some(item => {
                  areaGoodsNum += item.zoneselnum
                })
                if (areaGoodsNum < this.cardRule.selnum) {
                  this.$message({
                    type: 'error',
                    message: '专区可选择商品数量不能小于券卡可选择商品数量!'
                  });
                  return false
                }
                if (areaGoodsNum > this.cardRule.selnum) {
                  this.$message({
                    type: 'error',
                    message: '专区可选择商品数量不能大于券卡可选择商品数量!'
                  });
                  return false
                }
                let isTrue = true;
                this.cardRule.areainfo.some(item => {
                  if (item.listnum < item.zoneselnum) {
                    this.$message({
                      type: 'error',
                      message: `可选${item.zonename} 供选择商品数量不能小于可选择商品数量!`
                    });
                    isTrue = false;
                    return true
                  }
                })
                if (!isTrue) {
                  return false
                }
              }
            }
            let cardParams = {
              brandcode: this.brandInfo.brandcode, // 预售品牌
              goodscode: this.operGoodsCode,
              kindcode: this.operKindCode,
              cardkindinfo: {
                cardkind: this.cardRule.cardkind,
                selnum: this.cardRule.selnum,
                selzones: this.cardRule.selzones,
                defaultgoodscode: this.cardRule.defaultgoodscode ? this.cardRule.defaultgoodscode : '0',
                defaultgoodsname: this.cardRule.defaultgoodsname,
                usenum: this.cardRule.usenum,
                areainfo: this.cardRule.areainfo,
              }
            }
            if (this.cardRule.optsselecttype == 1) {
              cardParams.cardkindinfo.optsselecttype = 1;
            }else{
              cardParams.cardkindinfo.optsselecttype = 0;
            }
            if (this.cardRule.cardcategory) {
              cardParams.cardkindinfo.defaultgoodscode = '0';
              cardParams.cardkindinfo.defaultgoodsname = '';
              Vue.set(cardParams, 'cardcategory', 0)
              Vue.set(cardParams.cardkindinfo, 'goodspicknum', this.cardRule.goodspicknum)
              Vue.set(cardParams.cardkindinfo, 'minpicknumonce', this.cardRule.minpicknumonce)
            } else if (this.cardRule.tcCardcategory) {
              cardParams.cardkindinfo.defaultgoodscode = '0';
              cardParams.cardkindinfo.defaultgoodsname = '';
              Vue.set(cardParams, 'cardcategory', 1)
              Vue.set(cardParams.cardkindinfo, 'minpicknumonce', this.cardRule.minpicknumonce)
              cardParams.cardkindinfo.areainfo = []
              let arry = []
              this.cardRule.arrylist.map((item, index) => {
                let Objects = {
                  optgoodscode: item.kindcode,
                  optgoodsname: item.goodsname + ' ' + item.kindinfo,
                  zonename: '专区一',
                  listnum: 1,
                  sort: index + 1,
                  zoneselnum: item.remainnum,
                  remainnum: item.remainnum
                }
                arry.push(Objects)
              })
              cardParams.cardkindinfo.areainfo = arry
            } else if (this.cardRule.deCardcategory) {
              cardParams.cardkindinfo.defaultgoodscode = '0';
              cardParams.cardkindinfo.defaultgoodsname = '';
              Vue.set(cardParams, 'cardcategory', 2)
            } else {
              Vue.set(cardParams, 'cardcategory', null)
            }
            this.firstTrue = false;
            console.log(cardParams, 'cardParams')
            api.CREATEVOUCHERS(cardParams).then(res => {
              if (res.data.status == "200") {
                this.$message({
                  type: 'success',
                  message: res.data.message
                });
                this.autoGift = false;
                this.areaArrayStore({ deleteTrue: true })
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
              }
              this.firstTrue = true;
            }).catch(res => {
              this.firstTrue = true;
            })
          }
        } else {
          this.autoGift = false;
          this.areaArrayStore({ deleteTrue: true })
        }
      },
      //---------------券卡规则 method End-------------
      //动态获取表格高度
      getHeight() {
        let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
        //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
        this.tableHeight = window.innerHeight - tbHeight - 130;
      },
      // --------------------------------------- 单品管理 --------------------------------------- 2020/08/01
      // 关闭单品管理弹窗
      getClosePurchase(type) {
        if (type == 1) {
          if (this.singleErrList.length > 0) {
            let errorName = '';
            this.singleErrList.some(item => {
              if (!item.num) {
                errorName = item.singlename;
                return true;
              }
            })
            if (errorName) {
              this.$message({
                type: 'error',
                message: `单品-${errorName}，采购数量不能小于0！`
              })
              return false;
            }
          }
          // else {
          //   this.$message({
          //     type: 'error',
          //     message: '请选择采购单品！'
          //   })
          //   return false;
          // }
          // 单品采购提交
          this.bindSingleitem();
        } else {
          this.singleErrList = [];
          this.singleGoodsList = [];
          this.itemMaintenanceShow = false;
        }
      },
      // 采购设置单品商品
      setSingleGoods(arr) {
        this.singleErrList = [];
        this.singleGoodsList = [];
        if (arr.length > 0) {
          arr.forEach(item => {
            this.singleErrList.push(item);
            let info = {
              singlecode: item.singlecode,
              num: item.num,
              splitfeatures: item.splitfeatures,
            }
            this.singleGoodsList.push(info);
          })
        }
      },
      // 单品绑定提交
      bindSingleitem() {
        let bindParams = {
          goodscode: this.operGoodsCode,
          kindcode: this.operKindCode,
          singlearry: this.singleGoodsList
        }
        api.BINDSINGLEITEM(bindParams).then(res => {
          if (res.data.status == "200") {
            this.$message({
              type: 'success',
              message: res.data.message
            })
            this.singleGoodsList = [];
            this.itemMaintenanceShow = false;
            // 情况检索条件
            this.getGoodsList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            })
          }
        })
      },
      // 关闭一键复制创建商品信息弹框
      handleCloseAutoCreate(val) {
        if (val == 1) {
          // 清空检索条件
          this.querySubmit();
        }
        this.autoCreateShow = false;
      },
    },
    created() {
      //页面浏览器视窗变化绑定resize事件
      window.addEventListener("resize", this.getHeight);
    },
    mounted() {
      if(localStorage.getItem('userInfoMd')) {
        this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
      }
      // 公共配置
      let pubordprintinfo = this.config.getPubordprintinfo();
      if (pubordprintinfo && pubordprintinfo != 'null') {
        this.baseInvcontrol = pubordprintinfo.invcontrol; // 商家是否开启库存控制
      }
      if (this.ElementControls('openScheme') == 1) {
        this.useforLists.push({
          label: '福利方案',
          value: '3'
        })
      }
      if(this.ElementControls('OpenMiniProgram') == 1) {
        this.useforLists.push({
            label:'小程序商城',value:'4'
        })
      }
      // 获取公共服务基础配置
      if (localStorage.getItem('pubconfiginfo') && localStorage.getItem('pubconfiginfo') != 'null' && localStorage.getItem('pubconfiginfo') != undefined) {
        let pubConfigInfo = JSON.parse(localStorage.getItem('pubconfiginfo'))
        this.bopentclassify = pubConfigInfo.bopentclassify;
      }
      if (this.getCookie('opensupplyper')) {
        this.openSupplyper = this.getCookie('opensupplyper');
        this.sharestatus = this.getCookie('sharestatus');
      }
      // 获取商品列表数据
      this.getGoodsList();

    },
    destroyed() {
      window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    },
    activated() {
      if (this.patchName == '基本信息' || this.patchName == '规格管理' || this.patchName == '库存管理') {
        if (this.operateType != 1 || sessionStorage.getItem('addSpecify') == '1') {
          sessionStorage.setItem('addSpecify', '')
          Object.assign(this.$data, this.$options.data());
          if(localStorage.getItem('userInfoMd')) {
            this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
          }
          if (this.ElementControls('openScheme') == 1) {
            this.useforLists.push({
              label: '福利方案',
              value: '3'
            })
          }
          if(this.ElementControls('OpenMiniProgram') == 1) {
              this.useforLists.push({
                  label:'小程序商城',value:'4'
              })
          }
          // 公共配置
          let pubordprintinfo = this.config.getPubordprintinfo();
          if (pubordprintinfo && pubordprintinfo != 'null') {
            this.baseInvcontrol = pubordprintinfo.invcontrol; // 商家是否开启库存控制
          }
          // 获取公共服务基础配置
          if (localStorage.getItem('pubconfiginfo') && localStorage.getItem('pubconfiginfo') != 'null' && localStorage.getItem('pubconfiginfo') != undefined) {
            let pubConfigInfo = JSON.parse(localStorage.getItem('pubconfiginfo'))
            this.bopentclassify = pubConfigInfo.bopentclassify;
          }
          if (this.getCookie('opensupplyper')) {
            this.openSupplyper = this.getCookie('opensupplyper');
            this.sharestatus = this.getCookie('sharestatus');
          }
          // 获取商品列表数据
          this.getGoodsList();
          return false;
        } else {
          this.getGoodsList();
        }
      } else {
        sessionStorage.setItem('addSpecify', '')
        if (this.patchName) {
          Object.assign(this.$data, this.$options.data());
          if(localStorage.getItem('userInfoMd')) {
            this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
          }
          if (this.ElementControls('openScheme') == 1) {
            this.useforLists.push({
              label: '福利方案',
              value: '3'
            })
          }
          // 公共配置
          let pubordprintinfo = this.config.getPubordprintinfo();
          if (pubordprintinfo && pubordprintinfo != 'null') {
            this.baseInvcontrol = pubordprintinfo.invcontrol; // 商家是否开启库存控制
          }
          // 获取公共服务基础配置
          if (localStorage.getItem('pubconfiginfo') && localStorage.getItem('pubconfiginfo') != 'null' && localStorage.getItem('pubconfiginfo') != undefined) {
            let pubConfigInfo = JSON.parse(localStorage.getItem('pubconfiginfo'))
            this.bopentclassify = pubConfigInfo.bopentclassify;
          }
          if (this.getCookie('opensupplyper')) {
            this.openSupplyper = this.getCookie('opensupplyper');
            this.sharestatus = this.getCookie('sharestatus');
          }
          // 获取商品列表数据
          this.getGoodsList();
        }
      }
    },
  }
</script>
<style scoped>
  @import '../Css/style.css';

  .goodsBox {
    padding: 20px;
    height: calc(100% - 40px);
  }

  .gsTable>>>.el-table__header .el-form-item {
    margin-bottom: 0 !important;
  }

  .gsTable.el-table>>>thead.is-group>tr:first-child th .cell {
    overflow: visible !important;
  }

  .gsTable.el-table>>>thead.is-group>tr:nth-child(2) th .cell {
    color: #333;
  }

  .gsTable.el-table>>>.el-table__body .el-checkbox {
    padding: 20px;
  }

  .gsTable.el-table>>>.el-table__header .el-checkbox {
    padding: 0 20px;
  }

  .gsTable>>>.el-dropdown-link {
    cursor: pointer;
    color: var(--main-color);
  }

  /*生成礼品券规则 strart*/
  .outDetailDlog>>>.el-dialog {
    width: 1500px
  }

  .outDetailDlog>>>.el-tabs__item {
    color: #666
  }

  .outDetailDlog>>>.el-tabs__item.is-top {
    color: #333
  }

  .outDetailDlog>>>.el-tabs__item.is-active {
    color: var(--main-color) !important;
    padding-bottom: 2px
  }

  /*生成礼品券规则 end*/
  .riskPrice {
    line-height: 1.5;
    font-size: 14px;
    font-weight: normal;
  }

  .riskPrice em {
    font-size: 16px;
    margin-right: 5px;
  }

  .riskPrice i {
    color: #FA2F2F;
  }
</style>


// WEBPACK FOOTER //
// src/views/GoodsFolder/GoodsCommodity/GoodsList.vue